import { UserFormData } from '../../features/users/users.model';

export interface FieldDiff {
  field: string;
  oldValue: string;
  newValue: string;
  type: 'updated' | 'added' | 'removed';
}

export function computeUserDiff(original: UserFormData, current: UserFormData): FieldDiff[] {
  const diffs: FieldDiff[] = [];

  if (original.fullName !== current.fullName) {
    diffs.push({ field: 'Full name', oldValue: original.fullName, newValue: current.fullName, type: 'updated' });
  }
  if (original.email !== current.email) {
    diffs.push({ field: 'Email', oldValue: original.email, newValue: current.email, type: 'updated' });
  }
  if (original.phone !== current.phone) {
    diffs.push({ field: 'Phone', oldValue: original.phone, newValue: current.phone, type: 'updated' });
  }
  if (original.supervisoryLevel !== current.supervisoryLevel) {
    diffs.push({
      field: 'Supervisory Level',
      oldValue: original.supervisoryLevel ?? '—',
      newValue: current.supervisoryLevel ?? '—',
      type: 'updated'
    });
  }
  if ((original.role?.id ?? null) !== (current.role?.id ?? null)) {
    diffs.push({
      field: 'Role',
      oldValue: original.role?.name ?? '—',
      newValue: current.role?.name ?? '—',
      type: 'updated'
    });
  }
  if (original.PlatformAccess !== current.PlatformAccess) {
    diffs.push({
      field: 'Access Type',
      oldValue: original.PlatformAccess,
      newValue: current.PlatformAccess,
      type: 'updated'
    });
  }
  if ((original.supervisorId ?? null) !== (current.supervisorId ?? null)) {
    diffs.push({
      field: 'Supervisor',
      oldValue: original.supervisor?.name ?? '—',
      newValue: current.supervisor?.name ?? '—',
      type: 'updated'
    });
  }

  const origIds = original.geographicNodeIds ?? [];
  const currIds = current.geographicNodeIds ?? [];
  const addedNodes = currIds.filter(id => !origIds.includes(id));
  const removedNodes = origIds.filter(id => !currIds.includes(id));
  if (addedNodes.length || removedNodes.length) {
    diffs.push({
      field: 'Territory',
      oldValue: `${origIds.length} node${origIds.length !== 1 ? 's' : ''}`,
      newValue: `${currIds.length} node${currIds.length !== 1 ? 's' : ''}`,
      type: 'updated'
    });
  }

  return diffs;
}
